import { render } from "./OAuthConsent.vue?vue&type=template&id=daf697ae"
import script from "./OAuthConsent.vue?vue&type=script&lang=js"
export * from "./OAuthConsent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/OAuthConsent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "daf697ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('daf697ae', __exports__)) {
    api.reload('daf697ae', __exports__)
  }
  
  module.hot.accept("./OAuthConsent.vue?vue&type=template&id=daf697ae", () => {
    api.rerender('daf697ae', render)
  })

}


export default __exports__